
import { useState, useEffect } from 'react';
import { 
  FaEnvelope, 
  FaPhoneAlt, 
  FaMapMarkerAlt, 
  FaClock, 
  FaUser, 
  FaCommentDots,
  FaPaperPlane,
  FaHandsHelping,
  FaPenSquare
} from 'react-icons/fa';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you for your message. We will contact you soon.');
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <div className="contact-page">
      <div className="glass-container">
        <h1>Contact Us</h1>
        <p className="contact-subtitle">We're here to help you with your loan journey</p>
        
        <div className="contact-methods">
          <div className="contact-info">
            <h3><FaHandsHelping style={{ marginRight: '10px', color: 'var(--federal-yellow)' }} /> Get in Touch</h3>
            <div className="contact-cards">
              <div className="contact-card">
                <div className="contact-icon"><FaEnvelope /></div>
                <div className="contact-details">
                  <h4>Email</h4>
                  <p>Loanmadeeasy.socials@gmail.com</p>
                </div>
              </div>
              <div className="contact-card">
                <div className="contact-icon"><FaPhoneAlt /></div>
                <div className="contact-details">
                  <h4>Phone</h4>
                  <p>+91 91489 42560</p>
                </div>
              </div>
              <div className="contact-card">
                <div className="contact-icon"><FaMapMarkerAlt /></div>
                <div className="contact-details">
                  <h4>Address</h4>
                  <p>Bommanahali No. 234 Behind Ganesh Temple, Bangalore - 560076</p>
                </div>
              </div>
              <div className="contact-card">
                <div className="contact-icon"><FaClock /></div>
                <div className="contact-details">
                  <h4>Business Hours</h4>
                  <p>Mon-Fri: 9AM-6PM</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="contact-form-container">
            <h3><FaPenSquare style={{ marginRight: '10px', color: 'var(--federal-blue)' }} /> Send us a Message</h3>
            <form onSubmit={handleSubmit} className="contact-form">
              <div>
                <label><FaUser style={{ marginRight: '8px', fontSize: '0.9rem' }} /> Full Name:</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter your full name"
                  required
                />
              </div>
              <div>
                <label><FaEnvelope style={{ marginRight: '8px', fontSize: '0.9rem' }} /> Email Address:</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your email address"
                  required
                />
              </div>
              <div>
                <label><FaCommentDots style={{ marginRight: '8px', fontSize: '0.9rem' }} /> Message:</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Tell us how we can help you..."
                  rows="5"
                  required
                />
              </div>
              <button type="submit">
                <FaPaperPlane style={{ marginRight: '10px' }} /> Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
